import 'vant/lib/field/index.less'

// 依赖
import '../preview-text/style'
import './style.less'
